import { BaseComponent } from '../base.component';
import { environment } from 'src/environments/environment';

export class PublicBaseComponent extends BaseComponent {
  imgBaseUrl = environment.apiUrlImage;
  isURL(str: any): boolean {
    const pattern = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gmi;
    return pattern.test(str);
  }
}
